// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import "./railsui";
import autofocus_controller from "./autofocus_controller";

import HelloController from "./hello_controller";
import DropzoneController from "./dropzone_controller";

import QueriesBarChartController from "./queries/bar_chart_controller.js";
import QueriesRingChart from "./queries/ring_chart_controller.js";
import CallsBarChartController from "./call/bar_chart_controller.js";
import area_chart_controller from "./call/area_chart_controller.js";
import create_query_controller from "./create_query_controller.js";
import dynamic_fields_controller from "./dynamic_fields_controller.js";
import dialer_controller from "./dialer_controller.js";
import wavesurfer_controller from "./wavesurfer_controller.js";
import choices_controller from "./choices_controller.js";
import WidgetsQueriesReportController from "./widgets/queries_report_controller.js";
import WidgetsQueryStatisticsController from "./widgets/query_statistics_controller.js";
import WidgetsCallStatisticsController from "./widgets/call_statistics_controller.js";
import WidgetsQueryCategoriesController from "./widgets/query_categories_controller.js";
import WidgetsQueryStatusController from "./widgets/query_status_controller.js";
import WidgetsAgentsIncomingController from "./widgets/agents/incoming_controller.js";
import WidgetsAgentsAverageDurationController from "./widgets/agents/average_duration_controller.js";
import WidgetsAgentsAnsweredCallsController from "./widgets/agents/answered_calls_controller.js";
import WidgetsAgentsMissedCallsController from "./widgets/agents/missed_calls_controller.js";
import WidgetsAgentsOutgoingCallsController from "./widgets/agents/outgoing_calls_controller.js";
import WidgetsSupervisorCallsBreakdownController from "./widgets/supervisor/calls_breakdown_controller.js";
import WidgetsAgentsCallsBreakdownController from "./widgets/agents/calls_breakdown_controller.js";
import WidgetsSupervisorQueryBreakdownController from "./widgets/supervisor/query_breakdown_controller.js";
import keypad_controller from "./keypad_controller.js";
import reload_controller from "./reload_controller.js";
import sidebar_controller from "./sidebar_controller.js";
import click_outside_controller from "./click_outside_controller.js";
import switchable_controller from "./switchable_controller.js";
import scroll_to_controller from "./scroll_to_controller.js";
import enter_submit_controller from "./enter_submit_controller.js";
import datepicker_controller from "./datepicker_controller.js";

application.register("datepicker", datepicker_controller);
application.register("switchable", switchable_controller);
application.register("hello", HelloController);
application.register("dropzone", DropzoneController);
application.register("autofocus", autofocus_controller);
application.register("queries-bar-chart", QueriesBarChartController);
application.register("queries-ring-chart", QueriesRingChart);
application.register("calls-area-chart", area_chart_controller);
application.register("create-query", create_query_controller);
application.register("dynamic-fields", dynamic_fields_controller);
application.register("dialer", dialer_controller);
application.register("keypad", keypad_controller);
application.register("waveform", wavesurfer_controller);
application.register("choices", choices_controller);
application.register("calls-bar-chart", CallsBarChartController);
application.register("widgets--queries-report", WidgetsQueriesReportController);
application.register(
	"widgets--supervisor--query-breakdown",
	WidgetsSupervisorQueryBreakdownController,
);
application.register(
	"widgets--agents--calls-breakdown",
	WidgetsAgentsCallsBreakdownController,
);
application.register(
	"widgets--query-statistics",
	WidgetsQueryStatisticsController,
);
application.register(
	"widgets--call-statistics",
	WidgetsCallStatisticsController,
);
application.register(
	"widgets--query-categories",
	WidgetsQueryCategoriesController,
);
application.register("widgets--query-status", WidgetsQueryStatusController);
application.register(
	"widgets--agents-incoming",
	WidgetsAgentsIncomingController,
);
application.register(
	"widgets--agents--average-duration",
	WidgetsAgentsAverageDurationController,
);
application.register(
	"widgets--agents--answered-calls",
	WidgetsAgentsAnsweredCallsController,
);
application.register(
	"widgets--agents--missed-calls",
	WidgetsAgentsMissedCallsController,
);
application.register(
	"widgets--agents--outgoing-calls",
	WidgetsAgentsOutgoingCallsController,
);
application.register(
	"widgets--supervisor--calls-breakdown",
	WidgetsSupervisorCallsBreakdownController,
);

application.register("reload", reload_controller);
application.register("sidebar", sidebar_controller);
application.register("click-outside", click_outside_controller);
application.register("scroll-to", scroll_to_controller);
application.register("enter-submit", enter_submit_controller);
